import { SVGProps, Ref, forwardRef } from 'react';

export const TrashFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.664 15.996c4 0 5.332-1.333 5.332-5.332V4.7H15.5V3.3h-3.82C11.185 1.43 10.067 0 7.997 0S4.81 1.429 4.317 3.3H.5v1.4H2v5.964c0 4 1.332 5.332 5.331 5.332zM9.898 2.554q.185.334.322.746H5.776q.136-.412.322-.746c.415-.748.982-1.154 1.9-1.154s1.485.406 1.9 1.154m-4.266 10.11V6.665h1.4v5.999zm4.732 0V6.665h-1.4v5.999z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
TrashFilledSize16Glyph.displayName = 'TrashFilledSize16Glyph';
